<div id="payfrequencyJuncture" class="container">
  <div class="row">
    @if (!this.FlagService.flagServiceObject[7]['conditionsJunctureFlag']) {
      <div class="col-12 p-0">
        <div class="component-header __indicator">
          <h3 class="label m-0">{{ 'junctures.payFrequency.header' | translate }}</h3>
        </div>
      </div>
    }

    @if (!this.FlagService.flagServiceObject[7]['conditionsJunctureFlag']) {
      <div class="col-12 px-0">
        <ul>
          @for (option of mockedData; track option) {
            <li class="px-2" id="{{option.value}}" (click)="sendUserdata($event)">
              <span class="month fw-bold">{{ option.month }}</span>
              <fa-icon class="text-center me-3" [icon]="faCalendar"></fa-icon>
              <div class="text">
                <span class="label">{{ option.label }} - {{ option.amount | number:'1.0-0':'hu-HU' }} Ft</span>
              </div>
            </li>
          }
        </ul>
      </div>
    }

  </div>

  @if (this.FlagService.flagServiceObject[7]['conditionsJunctureFlag']) {
    <div class="row feedback-module" (click)="payfrequencyJunctureClick()">
      <div class="d-flex p-0">
        <a class="w-100">
          <fa-icon class="text-center ms-3 me-3" [icon]="faCalendar"></fa-icon>
          <div class="text">
            <span class="top">{{ this._feedbackLabel }}</span>
          </div>
        </a>
        <div class="flex-shrink-1">
          <fa-icon class="faInfoCircle me-2" [icon]="faInfoCircle"></fa-icon>
        </div>
      </div>
    </div>
  }
</div>
